import {
    AveragePremiumByTabName,
    GetAveragePremiumByTabNameParams,
    GetPeerAverageBenefitAmtParams,
    GetPeerAverageBenefitRankParams,
    GetPeerAveragePremiumNoLoginParams,
    GetPeerAveragePremiumParams,
    GetPeerAveragePremiumRankParams,
    GetPremiumComparisonByTypeParams,
    GetPremiumComparisonByTypeResponse,
    GetRankingParams,
    MyPeerAverageBenefitRank,
    PeerAverageBenefitAmt,
    PeerAveragePremium,
    PeerAveragePremiumNoLogin,
    PeerAveragePremiumRank,
    TopCoverageRanking,
    TopOrgRanking,
} from '$constants/api-infos'
import {externalInstance} from '$utils/api'
import {createTanstackQuery} from '$utils/createQuery'

// 로그인 (마데 연결 여부 상관 없음)
export const getPeerAveragePremiumQuery = createTanstackQuery<PeerAveragePremium[], GetPeerAveragePremiumParams>(
    (params) => ({
        url: '/insurance/resource/peer-average-premium',
        method: 'GET',
        fetcher: externalInstance,
        params,
    }),
)

// 미로그인
export const getPeerAveragePremiumNoLoginQuery = createTanstackQuery<
    PeerAveragePremiumNoLogin[],
    GetPeerAveragePremiumNoLoginParams
>((params) => ({
    url: '/insurance/resource/peer-average-premium-nologin',
    method: 'GET',
    fetcher: externalInstance,
    params,
}))

// 로그인 & 마데연결
export const getPeerAveragePremiumRankQuery = createTanstackQuery<
    PeerAveragePremiumRank[],
    GetPeerAveragePremiumRankParams
>((params) => ({
    url: '/insurance/resource/peer-average-premium-rank',
    method: 'GET',
    fetcher: externalInstance,
    params,
}))

export const getTopOrgRankingQuery = createTanstackQuery<TopOrgRanking[], GetRankingParams>((params) => ({
    url: '/insurance/resource/orgRanking',
    method: 'GET',
    fetcher: externalInstance,
    params,
}))

export const getTopCoverageRankingQuery = createTanstackQuery<TopCoverageRanking[], GetRankingParams>((params) => ({
    url: '/insurance/resource/coverageRanking',
    method: 'GET',
    fetcher: externalInstance,
    params,
}))

export const getAveragePremiumByTabNameQuery = createTanstackQuery<
    AveragePremiumByTabName[],
    GetAveragePremiumByTabNameParams
>((params) => ({
    url: '/insurance/resource/avg-premium-by-tabName',
    method: 'GET',
    fetcher: externalInstance,
    params,
}))

export const getPeerAverageBenefitAmountQuery = createTanstackQuery<
    PeerAverageBenefitAmt[],
    GetPeerAverageBenefitAmtParams
>((params) => ({
    url: '/insurance/resource/peer-average-benefit-amt',
    method: 'GET',
    fetcher: externalInstance,
    params,
}))

export const getPeerAverageBenefitRankQuery = createTanstackQuery<
    MyPeerAverageBenefitRank[],
    GetPeerAverageBenefitRankParams
>((params) => ({
    url: '/insurance/resource/peer-average-benefit-rank',
    method: 'GET',
    fetcher: externalInstance,
    params,
}))

export const getPremiumComparisonByTypeQuery = createTanstackQuery<
    GetPremiumComparisonByTypeResponse,
    GetPremiumComparisonByTypeParams
>((params) => ({
    url: '/insurance/resource/premium-comparison-by-type',
    method: 'GET',
    fetcher: externalInstance,
    params,
}))
